module.exports = __webpack_public_path__ + "static/media/logo_henkel.166d5430.png";